import { useState } from "react"
import { Dropdown } from "../../../components/Dropdown"
import { Modal } from "../../../components/Modal"
import styles from './DateFilterModal.module.css'
import { ReportPeriod, ReportType, setPeriodRange } from "../helpers"
import { ESTToUTC, nowInEST, UTCToEST } from "../../../utils/timezone"

const showContent = (dateFilter: ReportType) => {

    switch (dateFilter) {
        case ReportType.CUSTOM:
        case ReportType.CUSTOM_WEEK:
        case ReportType.CUSTOM_MONTH:
            return true

        default:
            return false
    }
}

enum Month {
    January = 0,
    February = 1,
    March = 2,
    April = 3,
    May = 4,
    June = 5,
    July = 6,
    August = 7,
    September = 8,
    October = 9,
    November = 10,
    December = 11,
}

export const DateFilterModal = (props: {
    initialPeriod: ReportType
    setDateFilterModal: React.Dispatch<React.SetStateAction<boolean>>
    setPeriod: React.Dispatch<React.SetStateAction<ReportPeriod>>

}) => {
    const { initialPeriod, setDateFilterModal, setPeriod } = props
    const [dateFilter, setDateFilter] = useState<ReportType>(initialPeriod)
    const [weekInput, setWeekInput] = useState<string>("0")
    const [monthInput, setMonthInput] = useState<Month>(Month.January)
    const [customPeriod, setCustomPeriod] = useState<{
        start: Date
        end: Date
    }>(
        {
            start: ESTToUTC(new Date(nowInEST.getFullYear(), nowInEST.getMonth(), nowInEST.getDate() - 1, 0)),
            end: ESTToUTC(new Date(nowInEST.getFullYear(), nowInEST.getMonth(), nowInEST.getDate() + 1, 0))
        }
    )

    const onSubmitOptions = () => {
        const now = nowInEST
        switch (dateFilter) {
            case ReportType.TODAY:
            case ReportType.YESTERDAY:
            case ReportType.THIS_WEEK:
            case ReportType.LAST_WEEK:
            case ReportType.THIS_MONTH:
            case ReportType.LAST_MONTH:
                setPeriod(setPeriodRange(dateFilter))
                break;

            case ReportType.CUSTOM_MONTH:
                setPeriod(setPeriodRange(
                    ReportType.CUSTOM_MONTH,
                    {
                        type: ReportType.CUSTOM_MONTH,
                        start: ESTToUTC(
                            new Date(now.getFullYear(), monthInput, 1)
                        ),
                        end: ESTToUTC(new Date(
                            now.getFullYear(), monthInput + 1, 1
                        ))
                    }
                ))
                break;
            case ReportType.CUSTOM_WEEK:
                let start = ESTToUTC(
                    new Date(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate() -
                        now.getDay() +
                        (now.getDay() === 0 ? -6 : 1) -
                        (7 * Number(weekInput))
                    )
                )
                let end = new Date(start)
                end.setDate(end.getDate() + 7)
                setPeriod(
                    setPeriodRange(
                        ReportType.CUSTOM_WEEK,
                        {
                            type: ReportType.CUSTOM_WEEK,
                            start: start,
                            end: end

                        }
                    )
                )
                break
            case ReportType.CUSTOM:
                setPeriod(
                    setPeriodRange(
                        ReportType.CUSTOM,
                        {
                            type: ReportType.CUSTOM,
                            start: customPeriod.start,
                            end: customPeriod.end
                        }
                    )
                )
                break
            default:
                break;
        }
        setDateFilterModal(false)
    }


    return <Modal onClose={() => setDateFilterModal(false)}>
        <form onSubmit={(e) => e.preventDefault()}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    Filter Dates
                </div>
                <div>
                    <Dropdown
                        value={dateFilter}
                        options={Object.values(ReportType)}
                        onSelect={(option) => setDateFilter(option as ReportType)}
                    />
                </div>
                {
                    showContent(dateFilter) && <div className={styles.content}>
                        {dateFilter === ReportType.CUSTOM_MONTH && <div>
                            <Dropdown
                                value={Month[monthInput]}
                                options={Object.keys(Month).filter((key) => isNaN(Number(key)))}
                                onSelect={(option) => setMonthInput(Month[option as keyof typeof Month])}
                            />
                        </div>}
                        {dateFilter === ReportType.CUSTOM_WEEK && <div>
                            <input value={weekInput} onChange={((e) => setWeekInput(e.target.value))} />
                            <p>Weeks</p>
                        </div>}
                        {dateFilter === ReportType.CUSTOM && <div>
                            <input
                                type="date"
                                value={UTCToEST(customPeriod.start, true)}
                                onChange={(e) =>
                                    setCustomPeriod((p) => ({
                                        ...p,
                                        start: e.target.value
                                            ? ESTToUTC(
                                                new Date(
                                                    e.target.value +
                                                    'T00:00:00'
                                                )
                                            )
                                            : p.start,
                                    }))
                                }
                            />
                            <input
                                type="date"
                                value={UTCToEST(
                                    new Date(
                                        customPeriod.end.getTime() -
                                        24 * 60 * 60 * 1000
                                    ),
                                    true
                                )}
                                onChange={(e) =>
                                    setCustomPeriod((p) => ({
                                        ...p,
                                        end: e.target.value
                                            ? // manually add one day so it fetches inclusive of that day
                                            ESTToUTC(
                                                new Date(
                                                    new Date(
                                                        e.target.value +
                                                        'T00:00:00'
                                                    ).getTime() +
                                                    24 * 60 * 60 * 1000
                                                )
                                            )
                                            : p.end,
                                    }))
                                }
                            />
                        </div>}
                    </div>
                }
                <button type="submit" onMouseDown={() => onSubmitOptions()}>
                    Search
                </button>
            </div>
        </form>
    </Modal>
}